export const HOW_DID_YOU_HEAR_OPTIONS = [
    { key: 'Internet Search', label: 'Internet Search'},
    { key: 'Local Ad', label: 'Local Ad'},
    { key: 'Newspaper', label: 'Newspaper'},
    { key: 'Previous Customer', label: 'Previous Customer'},
    { key: 'Friends & Family', label: 'Friends & Family'},
    { key: 'Other', label: 'Other'},
];

export default HOW_DID_YOU_HEAR_OPTIONS;



// WEBPACK FOOTER //
// ./app/torchmark/options/HOW_DID_YOU_HEAR_OPTIONS.js